module.exports = __webpack_public_path__ + "img/address_icon.d2d83214.png";